class splashScreen{
    
    hide(){
        document.body.classList.remove('splashScreen');
        setTimeout(()=>{
            document.getElementById('splashScreen').style.display = 'none';
        }, 600);
    }

    show(){
        document.getElementById('splashScreen').style.display = '';
        document.body.classList.add('splashScreen');
    }

}

module.exports = new splashScreen();